import React, { useState } from 'react';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function ContactPage() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    weddingDate: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: 'info', message: t('contact.sendingMessage') });

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus({ type: 'success', message: t('contact.successMessage') });
        setFormData({ name: '', email: '', weddingDate: '', message: '' });
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      setStatus({ type: 'error', message: t('contact.errorMessage') });
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-8 bg-gradient-to-b from-pink-200 to-white">
      <div className="w-full max-w-lg bg-white/90 rounded-2xl shadow-lg p-8 md:p-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6 text-center">
          {t('contact.title')}
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          {t('contact.description')}
        </p>

        {status.message && (
          <div className={`mb-6 p-4 rounded-lg ${
            status.type === 'success' ? 'bg-green-100 text-green-700' :
            status.type === 'error' ? 'bg-red-100 text-red-700' :
            'bg-blue-100 text-blue-700'
          }`}>
            {status.type === 'info' ? t('contact.sendingMessage') : 
             status.type === 'success' ? t('contact.successMessage') : 
             t('contact.errorMessage')}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              {t('contact.nameLabel')}
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-pink-500 focus:border-pink-500"
              placeholder={t('contact.namePlaceholder')}
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              {t('contact.emailLabel')}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-pink-500 focus:border-pink-500"
              placeholder={t('contact.emailPlaceholder')}
            />
          </div>

          <div>
            <label htmlFor="weddingDate" className="block text-sm font-medium text-gray-700 mb-1">
              {t('contact.weddingDateLabel')}
            </label>
            <input
              type="date"
              id="weddingDate"
              name="weddingDate"
              value={formData.weddingDate}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-pink-500 focus:border-pink-500"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
              {t('contact.messageLabel')}
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-pink-500 focus:border-pink-500"
              placeholder={t('contact.messagePlaceholder')}
            />
          </div>

          <button
            type="submit"
            className="w-full px-6 py-3 bg-pink-500 hover:bg-pink-600 text-white text-lg font-semibold rounded-xl transition shadow-md"
          >
            {t('contact.sendButton')}
          </button>
        </form>
      </div>
      
      {/* Social Media Contact Buttons - Fixed Bottom Left */}
      <div className="fixed bottom-4 left-4 flex flex-col gap-2 z-50">
        <a
          href="https://wa.me/905372243441"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white/90 text-green-600 border border-green-300 rounded-full px-4 py-2 shadow-lg hover:bg-green-50 transition text-sm font-semibold flex items-center gap-2"
          style={{textDecoration: 'none'}}
        >
          <FaWhatsapp size={16} />
          {t('social.whatsapp')}
        </a>
        <a
          href="https://instagram.com/weddingram.me"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white/90 text-pink-600 border border-pink-300 rounded-full px-4 py-2 shadow-lg hover:bg-pink-50 transition text-sm font-semibold flex items-center gap-2"
          style={{textDecoration: 'none'}}
        >
          <FaInstagram size={16} />
          {t('social.instagram')}
        </a>
      </div>
    </div>
  );
}

export default ContactPage; 